import { joinCsvRows, toCsvRow, type CsvValue } from '@terros/common'

export function toCsvContent(headers: readonly string[], rows: readonly CsvValue[][]): string {
  return joinCsvRows([headers, ...rows].map(toCsvRow))
}

export function downloadCsv(csv: string, fileName: string): void {
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  downloadFile(url, fileName, 'csv')
}

export function downloadFile(url: string, fileName?: string, format: 'json' | 'csv' = 'csv'): void {
  const a = document.createElement('a')
  a.href = url
  if (fileName) a.download = `${fileName}.${format}`
  a.click()
  URL.revokeObjectURL(url)
}
